export const titles = [
  { span: 11, name: 'Наименование' },
  { span: 11, name: 'СЗВМ' },
  { span: 11, name: 'Описание' },
]
